
<template>
  <div>
    <printView
      :htmlDataList="htmlDataList"
      :showprint="showprint"
      v-if="showprint"
      :changeList="changeList"
      :modules="modules"
      @close="closeShow()"
      :btnLoading="btnLoading"
      :printData="printData"
      :printFun="printFun"
      :printTitle="printTitle"
      :printDragType="printDragType"
      :printDragUrl="printDragUrl"
      :printDragIdList="printDragIdList"
      @handleAvatarChange="handleAvatarChange"
      @handleAvatarSuccess="handleAvatarSuccess"
      :printOrderName="printOrderName"
      :printDetailParamName="printDetailParamName"
      :printDetailParamValue="printDetailParamValue"
      :presetTemplateDetails="presetTemplateDetails"
      :presetTemplateId="presetTemplateId"
      :skipPicker="skipPicker"
    ></printView>
  </div>
</template>

<script>
import { modulesList, processModules, fallbackPrintFromChangeList } from './printModules';
export default {
  props: {
    printTitle: {
      type: String,
      default: ''
    },
    groupGet: {
      type: Boolean,
      default: false
    },
    supGet: {
      type: Boolean,
      default: false
    },
    modules: {
      type: Number,
      default: 0
    },
    showprint: {
      type: Boolean,
      default: false
    },
    changeList: {
      type: Array,
      default() {
        return [];
      }
    },
    printFun: {
      type: Function,
      default: null
    },
    groupPrintFun: {
      type: Function,
      default: null
    },
    filterList: {
      type: Array,
      default() {
        return [];
      }
    },
    supKey: {
      type: String,
      default: 'table'
    },
    filterKey: {
      type: String,
      default: ''
    },
    printDragType: {
      type: String,
      default: null
    },
    printDragUrl: {
      type: String,
      default: null
    },
    printDragIdList: {
      type: Array,
      default() {
        return [];
      }
    },
    printOrderName: {
      type: String,
      default: null
    },
    printDetailParamName: {
      type: String,
      default: null
    },
    printDetailParamValue: {
      type: String,
      default: null
    },
    presetTemplateDetails: {
      type: String,
      default: null
    },
    presetTemplateId: {
      type: [String, Number],
      default: null
    },
    skipPicker: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      htmlDataList: '',
      btnLoading: false,
      printData: [],
      modulesList
    };
  },
  mounted() {
    this.getPrintData();
  },
  methods: {
    async getPrintData() {
      const sourceList = this.changeList || [];
      let list = sourceList.map((item, index) => ({
        ...item,
        printid: index
      }));
      try {
        list = JSON.parse(JSON.stringify(list));
      } catch (error) {
        console.error('getPrintData clone', error);
      }
      this.btnLoading = true;
      try {
        const res = await processModules(
          this,
          list,
          this.modules,
          this.printFun,
          this.groupPrintFun,
          this.groupGet,
          this.supGet,
          this.filterList,
          this.filterKey,
          this.supKey,
          this.printOrderName,
          this.printDetailParamName,
          this.printDetailParamValue
        );
        this.printData = res || [];
        if (!this.printData.length && list.length) {
          this.printData = await fallbackPrintFromChangeList(list, this.modules);
        }
      } finally {
        this.btnLoading = false;
      }
    },
    handleAvatarSuccess(res, file) {
      this.$emit('handleAvatarSuccess', res, file);
    },
    handleAvatarChange(file, fileList) {
      this.$emit('handleAvatarChange', file);
    },
    closeShow() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.e-pr {
  width: 100%;
  top: 20%;
}
</style>
